import { z } from "zod"

export const readingDataSummarySchema = z.object({
  quantityUnit: z.string(),
  numberOfReadings: z.number(),
  fromDateTime: z.string(),
  toDateTime: z.string(),
})

export type ReadingDataSummary = z.infer<typeof readingDataSummarySchema>
